import { keys } from '@core/Services/Analytics/keys'
import { trackEvent } from '@core/Services/Analytics/track'

export const trackVenueModeHeaderClick = () => {
  trackEvent(keys.navigationClick, {
    interaction_type: 'Navigate to Venue Mode',
    location: 'Header',
  })
}
